import React from 'react'
import PropTypes from 'prop-types'
import { getEventLink, setColorTheme } from 'theme/utils/generic-helpers'
import { Link } from 'gatsby'
import Countdown from './countdown'

const WatchLiveAnnouncement = ({ conference, conferenceLocation, startTime, stageDays }) => {
  if (stageDays) {
    const sortedStageDays = stageDays
      .filter((stageDay) => stageDay.data.Stage?.[0]?.data?.Stage_Slug === 'main')
      .sort((a, b) => a.data.UTC_Start_Time - b.data.UTC_Start_Time)

    // get the current or next day
    const futureStageDays = sortedStageDays.filter(
      (stageDay) => new Date(stageDay.data.UTC_Start_Time).getTime() > Date.now(),
    )
    // const pastStageDays = sortedStageDays.filter((stageDay) => new Date(stageDay.data.UTC_End_Time).getTime() < Date.now())
    const currentStageDay = sortedStageDays.filter(
      (stageDay) =>
        new Date(stageDay.data.UTC_Start_Time).getTime() < Date.now() &&
        new Date(stageDay.data.UTC_End_Time).getTime() > Date.now(),
    )

    const currentState = currentStageDay.length > 0 ? 'live' : futureStageDays.length > 0 ? 'future' : 'past'

    if (currentState !== 'past' && startTime) {
      return (
        <div className="relative py-16 bg-white">
          <div className="hidden absolute top-0 inset-x-0 h-1/2 bg-gray-50 lg:block" aria-hidden="true" />
          <div className=" max-w-7xl mx-auto  lg:bg-transparent lg:px-8">
            <div
              className={`${setColorTheme(
                'bg-community-600 bg-apac-600 bg-emea-600 bg-usa-600',
                conferenceLocation,
              )} relative py-16 lg:rounded-3xl lg:items-center`}
            >
              <div
                className="hidden absolute inset-0 overflow-hidden rounded-3xl lg:block"
                aria-hidden="true"
              >
                <svg
                  className="absolute bottom-full left-full transform translate-y-1/3 -translate-x-2/3 xl:bottom-auto xl:top-0 xl:translate-y-0"
                  width="404"
                  height="384"
                  fill="none"
                  viewBox="0 0 404 384"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x="0"
                        y="0"
                        width="4"
                        height="4"
                        className={`${setColorTheme(
                          'text-community-500 text-apac-500 text-emea-500 text-usa-500',
                          conferenceLocation,
                        )}`}
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect width="404" height="384" fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
                </svg>
                {/* <svg className='absolute top-full transform -translate-y-1/3 -translate-x-1/3 xl:-translate-y-1/2' width='404' height='384' fill='none' viewBox='0 0 404 384' aria-hidden='true'>
                  <defs>
                    <pattern id='64e643ad-2176-4f86-b3d7-f2c5da3b6a6d' x='0' y='0' width='20' height='20' patternUnits='userSpaceOnUse'>
                      <rect x='0' y='0' width='4' height='4' className={`${setColorTheme('text-community-500 text-apac-500 text-emea-500 text-usa-500', conferenceLocation)}`} fill='currentColor' />
                    </pattern>
                  </defs>
                  <rect width='404' height='384' fill='url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)' />
                </svg> */}
              </div>
              <div className="relative max-w-md mx-auto py-12 px-8 md:px-16 lg:px-20 space-y-6 sm:max-w-3xl sm:py-16 sm:px-6 lg:max-w-none lg:p-0 lg:col-start-4 lg:col-span-6">
                <h2 className="text-3xl font-extrabold text-white" id="join-heading">
                  Watch Live
                </h2>
                {currentState === 'live' && (
                  <div className="text-xl text-white">The conference is now on.</div>
                )}
                {currentState === 'future' && (
                  <div className="text-xl text-white">
                    The conference starts in{' '}
                    <Countdown startTime={futureStageDays[0].data.UTC_Start_Time} inline />.
                  </div>
                )}
                <p className="text-xl text-white">
                  Go to the Event section to visit the stages, networking and expo opportunities.
                </p>
                <Link
                  to={getEventLink(conference.data.Conference_Id, conferenceLocation, 'live')}
                  className={`${setColorTheme(
                    'text-community-700 text-apac-700 text-emea-700 text-usa-700',
                    conferenceLocation,
                  )} block w-full py-3 px-5 text-center bg-white border border-transparent rounded-md shadow-md text-base font-medium hover:bg-gray-50 sm:inline-block sm:w-auto`}
                >
                  {new Date(startTime).getTime() < Date.now() ? 'Watch Now' : 'Explore Now'}
                </Link>
              </div>
            </div>
          </div>
        </div>
      )
    } else return <></>
  } else return <></>
}

WatchLiveAnnouncement.propTypes = {
  conference: PropTypes.object.isRequired,
  conferenceLocation: PropTypes.string.isRequired,
}

export default WatchLiveAnnouncement
